module.exports = {
  thinkOfEngland: {
    jp: {
      asin: 'B08CK9CLQM',
      title: 'イングランドを想え',
      url: 'https://www.amazon.co.jp/dp/B08CK9CLQM?tag=muchimemo-22',
      author: 'KJ･チャールズ',
      rakuten:
        'https://hb.afl.rakuten.co.jp/ichiba/1ce58288.c1901dcf.1ce58289.c2be2c6c/?pc=https%3A%2F%2Fitem.rakuten.co.jp%2Frakutenkobo-ebooks%2Fae7c5c753a6b35fe97706215f8a7a59a%2F&link_type=hybrid_url&ut=eyJwYWdlIjoiaXRlbSIsInR5cGUiOiJoeWJyaWRfdXJsIiwic2l6ZSI6IjI0MHgyNDAiLCJuYW0iOjEsIm5hbXAiOiJyaWdodCIsImNvbSI6MSwiY29tcCI6ImxlZnQiLCJwcmljZSI6MCwiYm9yIjoxLCJjb2wiOjAsImJidG4iOjEsInByb2QiOjB9',
      renta:
        '//ck.jp.ap.valuecommerce.com/servlet/referral?sid=3549505&pid=886731192&vc_url=https%3A%2F%2Frenta.papy.co.jp%2Frenta%2Fsc%2Ffrm%2Fitem%2F218675%2F%3Fref%3Dvc',
      cmoa:
        '//ck.jp.ap.valuecommerce.com/servlet/referral?sid=3549505&pid=886731152&vc_url=https%3A%2F%2Fwww.cmoa.jp%2Ftitle%2F1101282317%2F%3F%2F%3Fcmoa%3Ditag01%26cmoa_pg%3D125%26itag01%3D',
      ebookjapan:
        '//ck.jp.ap.valuecommerce.com/servlet/referral?sid=3549505&pid=886731133&vc_url=https%3A%2F%2Febookjapan.yahoo.co.jp%2Fbooks%2F597885%2FA002412805%2F%3Fdealerid%3D30064%26utm_source%3Dasp%26utm_medium%3Dvc%26utm_campaign%3Drate',
      honto:
        '//ck.jp.ap.valuecommerce.com/servlet/referral?sid=3549505&pid=886731272&vc_url=https%3A%2F%2Fhonto.jp%2Febook%2Fpd_30431751.html%3Fpartnerid%3D02vc01',
    },
    en: {
      asin: 'B077J4Y2BZ',
      title: 'Think of England',
      url: 'https://www.amazon.co.jp/dp/B077J4Y2BZ?tag=muchimemo-22',
      author: 'KJ Charles',
      rakuten:
        'https://hb.afl.rakuten.co.jp/ichiba/1ce58288.c1901dcf.1ce58289.c2be2c6c/?pc=https%3A%2F%2Fitem.rakuten.co.jp%2Frakutenkobo-ebooks%2F7d9e84d0a37d3350ac053a683ede958a%2F&link_type=hybrid_url&ut=eyJwYWdlIjoiaXRlbSIsInR5cGUiOiJoeWJyaWRfdXJsIiwic2l6ZSI6IjI0MHgyNDAiLCJuYW0iOjEsIm5hbXAiOiJyaWdodCIsImNvbSI6MSwiY29tcCI6ImxlZnQiLCJwcmljZSI6MCwiYm9yIjoxLCJjb2wiOjAsImJidG4iOjEsInByb2QiOjB9',
    },
  },
  diversion: {
    jp: {
      asin: 'B01LZ2CASG',
      title: '還流 (ドラッグ･チェイス #1)',
      url: 'https://www.amazon.co.jp/dp/B01LZ2CASG?tag=muchimemo-22',
      author: 'エデン･ウィンターズ',
      rakuten:
        'https://hb.afl.rakuten.co.jp/ichiba/1ce58288.c1901dcf.1ce58289.c2be2c6c/?pc=https%3A%2F%2Fitem.rakuten.co.jp%2Frakutenkobo-ebooks%2F51a421202db930a1b732fa965e05ce90%2F&link_type=hybrid_url&ut=eyJwYWdlIjoiaXRlbSIsInR5cGUiOiJoeWJyaWRfdXJsIiwic2l6ZSI6IjI0MHgyNDAiLCJuYW0iOjEsIm5hbXAiOiJyaWdodCIsImNvbSI6MSwiY29tcCI6ImxlZnQiLCJwcmljZSI6MCwiYm9yIjoxLCJjb2wiOjAsImJidG4iOjEsInByb2QiOjB9',
      renta:
        '//ck.jp.ap.valuecommerce.com/servlet/referral?sid=3549505&pid=886731192&vc_url=https%3A%2F%2Frenta.papy.co.jp%2Frenta%2Fsc%2Ffrm%2Fitem%2F115942%2F%3Fref%3Dvc',
      cmoa:
        '//ck.jp.ap.valuecommerce.com/servlet/referral?sid=3549505&pid=886731152&vc_url=https%3A%2F%2Fwww.cmoa.jp%2Ftitle%2F1101161169%2F%3F%2F%3Fcmoa%3Ditag01%26cmoa_pg%3D125%26itag01%3D',
      ebookjapan:
        '//ck.jp.ap.valuecommerce.com/servlet/referral?sid=3549505&pid=886731133&vc_url=https%3A%2F%2Febookjapan.yahoo.co.jp%2Fbooks%2F382967%2FA001685720%2F%3Fdealerid%3D30064%26utm_source%3Dasp%26utm_medium%3Dvc%26utm_campaign%3Drate',
      honto:
        '//ck.jp.ap.valuecommerce.com/servlet/referral?sid=3549505&pid=886731272&vc_url=https%3A%2F%2Fhonto.jp%2Febook%2Fpd_28129837.html%3Fpartnerid%3D02vc01',
    },
    en: {
      asin: 'B00LIC5J00',
      title: 'Diversion (Diversion #1)',
      url: 'https://www.amazon.co.jp/dp/B00LIC5J00?tag=muchimemo-22',
      author: 'Eden Winters',
      rakuten:
        'https://hb.afl.rakuten.co.jp/ichiba/1ce58288.c1901dcf.1ce58289.c2be2c6c/?pc=https%3A%2F%2Fitem.rakuten.co.jp%2Frakutenkobo-ebooks%2F42ca0f22dab5361e88be4a0f9c339589%2F&link_type=hybrid_url&ut=eyJwYWdlIjoiaXRlbSIsInR5cGUiOiJoeWJyaWRfdXJsIiwic2l6ZSI6IjI0MHgyNDAiLCJuYW0iOjEsIm5hbXAiOiJyaWdodCIsImNvbSI6MSwiY29tcCI6ImxlZnQiLCJwcmljZSI6MCwiYm9yIjoxLCJjb2wiOjAsImJidG4iOjEsInByb2QiOjB9',
    },
    audiobook: {
      asin: 'B07J5QVK74',
      url: 'https://www.amazon.co.jp/dp/B07J5QVK74?tag=muchimemo-22',
      narrator: 'Darcy Stark',
    },
  },
  collusion: {
    jp: {
      asin: '',
      title: '',
      url: '',
      author: '',
      rakuten: '',
    },
    en: {
      asin: 'B00ZDFRJCO',
      title: 'Collusion (Diversion #2)',
      url: 'https://www.amazon.co.jp/dp/B00ZDFRJCO?tag=muchimemo-22',
      author: 'Eden Winters',
      rakuten: '',
    },
  },
  highwayMan: {
    jp: {
      asin: '',
      title: '',
      url: '',
      author: '',
      rakuten: '',
    },
    en: {
      asin: 'B00LYDWC0S',
      title: 'Highway Man',
      url: 'https://www.amazon.co.jp/dp/B00LYDWC0S?tag=muchimemo-22',
      author: 'Eden Winters',
      rakuten: '',
    },
  },
  drifter: {
    jp: {
      asin: '',
      title: '',
      url: '',
      author: '',
      rakuten: '',
    },
    en: {
      asin: 'B089G68SSS',
      title: 'Drifter',
      url: 'https://www.amazon.co.jp/dp/B089G68SSS?tag=muchimemo-22',
      author: 'Eden Winters',
      rakuten: '',
    },
  },
  glitterland: {
    jp: {
      asin: '',
      title: '',
      url: '',
      author: '',
      rakuten: '',
    },
    en: {
      asin: 'B07BKTXQPG',
      title: 'Glitterland',
      url: '',
      author: 'Alexis Hall',
      rakuten: '',
    },
  },
  forReal: {
    jp: {
      asin: '',
      title: '',
      url: '',
      author: '',
      rakuten: '',
    },
    en: {
      asin: 'B07BRD69LV',
      title: 'For Real',
      url: 'https://www.amazon.co.jp/dp/B07BRD69LV?tag=muchimemo-22',
      author: 'Alexis Hall',
      rakuten: '',
    },
  },
  redWhiteRoyalBlue: {
    jp: {
      asin: '4576210068',
      title: '赤と白とロイヤルブルー',
      url: 'https://www.amazon.co.jp/dp/B08YNJVHS7?tag=muchimemo-22',
      author: 'ケイシー･マクイストン',
      rakuten: '',
    },
    en: {
      asin: 'B07J4LPZRN',
      title: 'Red, White & Royal Blue',
      url: 'https://www.amazon.co.jp/dp/B07J4LPZRN?tag=muchimemo-22',
      author: 'Casey McQuiston',
      rakuten: '',
    },
  },
  him: {
    jp: {
      asin: '',
      title: '',
      url: '',
      author: '',
      rakuten: '',
    },
    en: {
      asin: 'B011LSLI9G',
      title: 'Him',
      url: 'https://www.amazon.co.jp/dp/B011LSLI9G?tag=muchimemo-22',
      author: 'Sarina Bowen, Elle Kennedy',
      rakuten: '',
    },
  },
  hisRoyalSecret: {
    jp: {
      asin: 'B081639HQ8',
      title: 'ロイヤル･シークレット',
      url: 'https://www.amazon.co.jp/dp/B081639HQ8?tag=muchimemo-22',
      author: 'ライラ･ペース',
      rakuten:
        'https://hb.afl.rakuten.co.jp/ichiba/1ce58288.c1901dcf.1ce58289.c2be2c6c/?pc=https%3A%2F%2Fitem.rakuten.co.jp%2Frakutenkobo-ebooks%2F71e0643c55393a8385da91d9f2a98014%2F&link_type=hybrid_url&ut=eyJwYWdlIjoiaXRlbSIsInR5cGUiOiJoeWJyaWRfdXJsIiwic2l6ZSI6IjI0MHgyNDAiLCJuYW0iOjEsIm5hbXAiOiJyaWdodCIsImNvbSI6MSwiY29tcCI6ImRvd24iLCJwcmljZSI6MSwiYm9yIjoxLCJjb2wiOjEsImJidG4iOjEsInByb2QiOjAsImFtcCI6ZmFsc2V9',
      renta:
        '//ck.jp.ap.valuecommerce.com/servlet/referral?sid=3549505&pid=886731192&vc_url=https%3A%2F%2Frenta.papy.co.jp%2Frenta%2Fsc%2Ffrm%2Fitem%2F201371%2F%3Fref%3Dvc',
      cmoa:
        '//ck.jp.ap.valuecommerce.com/servlet/referral?sid=3549505&pid=886731152&vc_url=https%3A%2F%2Fwww.cmoa.jp%2Ftitle%2F1101260884%2F%3F%2F%3Fcmoa%3Ditag01%26cmoa_pg%3D125%26itag01%3D',
      ebookjapan:
        '//ck.jp.ap.valuecommerce.com/servlet/referral?sid=3549505&pid=886731133&vc_url=https%3A%2F%2Febookjapan.yahoo.co.jp%2Fbooks%2F568681%2FA002281157%2F%3Fdealerid%3D30064%26utm_source%3Dasp%26utm_medium%3Dvc%26utm_campaign%3Drate',
      honto:
        '//ck.jp.ap.valuecommerce.com/servlet/referral?sid=3549505&pid=886731272&vc_url=https%3A%2F%2Fhonto.jp%2Febook%2Fpd_30012792.html%3Fpartnerid%3D02vc01',
    },
    en: {
      asin: 'B01CFBV2O4',
      title: 'His Royal Secret',
      url: 'https://www.amazon.co.jp/dp/B01CFBV2O4?tag=muchimemo-22',
      author: 'Lilah Pace',
      rakuten: '',
    },
  },
  hisRoyalFavorite: {
    jp: {
      asin: 'B08Q351XDM',
      title: 'ロイヤル･フェイバリット',
      url: 'https://www.amazon.co.jp/dp/B08Q351XDM?tag=muchimemo-22',
      author: 'ライラ･ペース',
      renta:
        'https://ck.jp.ap.valuecommerce.com/servlet/referral?sid=3549505&pid=886731192&vc_url=https%3A%2F%2Frenta.papy.co.jp%2Frenta%2Fsc%2Ffrm%2Fitem%2F201371%2Ftitle%2F776044%2F%3Fref%3Dvc',
    },
    en: {
      asin: 'B01CFBV34S',
      title: 'His Royal Favorite',
      url: 'https://www.amazon.co.jp/dp/B01CFBV34S?tag=muchimemo-22',
      author: 'Lilah Pace',
    },
  },
  mermaidMurders: {
    jp: {
      asin: 'B07L8WN6FL',
      title: 'マーメイド･マーダーズ (殺しのアート #1)',
      url: 'https://www.amazon.co.jp/dp/B07L8WN6FL?tag=muchimemo-22',
      author: 'ジョシュ･ラニヨン',
      rakuten:
        'https://hb.afl.rakuten.co.jp/ichiba/1ce58288.c1901dcf.1ce58289.c2be2c6c/?pc=https%3A%2F%2Fitem.rakuten.co.jp%2Frakutenkobo-ebooks%2F157fc3147bfd3ae59358257d59d7b570%2F&link_type=hybrid_url&ut=eyJwYWdlIjoiaXRlbSIsInR5cGUiOiJoeWJyaWRfdXJsIiwic2l6ZSI6IjI0MHgyNDAiLCJuYW0iOjEsIm5hbXAiOiJyaWdodCIsImNvbSI6MSwiY29tcCI6ImxlZnQiLCJwcmljZSI6MCwiYm9yIjoxLCJjb2wiOjAsImJidG4iOjEsInByb2QiOjB9',
      renta:
        '//ck.jp.ap.valuecommerce.com/servlet/referral?sid=3549505&pid=886731192&vc_url=https%3A%2F%2Frenta.papy.co.jp%2Frenta%2Fsc%2Ffrm%2Fitem%2F180398%2Ftitle%2F608253%2F%3Fref%3Dvc',
      cmoa:
        '//ck.jp.ap.valuecommerce.com/servlet/referral?sid=3549505&pid=886731152&vc_url=https%3A%2F%2Fwww.cmoa.jp%2Ftitle%2F1101234738%2Fvol%2F1%2F%3F%2F%3Fcmoa%3Ditag01%26cmoa_pg%3D125%26itag01%3D',
      ebookjapan:
        '//ck.jp.ap.valuecommerce.com/servlet/referral?sid=3549505&pid=886731133&vc_url=https%3A%2F%2Febookjapan.yahoo.co.jp%2Fbooks%2F526517%2FA002119223%2F%3Fdealerid%3D30064%26utm_source%3Dasp%26utm_medium%3Dvc%26utm_campaign%3Drate',
      honto:
        '//ck.jp.ap.valuecommerce.com/servlet/referral?sid=3549505&pid=886731272&vc_url=https%3A%2F%2Fhonto.jp%2Febook%2Fpd_29528822.html%3Fpartnerid%3D02vc01',
    },
    en: {
      asin: 'B018UJ80EA',
      title: 'The Mermaid Murders (The Art of Murder #1)',
      url: 'https://www.amazon.co.jp/dp/B018UJ80EA?tag=muchimemo-22',
      author: 'Josh Lanyon',
    },
    audiobook: {
      asin: 'B07DVCS2G7',
      url: 'https://www.amazon.co.jp/dp/B07DVCS2G7?tag=muchimemo-22',
      narrator: 'Kale Williams',
    },
  },
  monetMurders: {
    jp: {
      asin: 'B082H6P92M',
      title: 'モネ･マーダーズ (殺しのアート #2)',
      url: 'https://www.amazon.co.jp/dp/B082H6P92M?tag=muchimemo-22',
      author: 'ジョシュ･ラニヨン',
      rakuten:
        'https://hb.afl.rakuten.co.jp/ichiba/1ce58288.c1901dcf.1ce58289.c2be2c6c/?pc=https%3A%2F%2Fitem.rakuten.co.jp%2Frakutenkobo-ebooks%2F011087e602b6373098d94c425a9413d7%2F&link_type=hybrid_url&ut=eyJwYWdlIjoiaXRlbSIsInR5cGUiOiJoeWJyaWRfdXJsIiwic2l6ZSI6IjI0MHgyNDAiLCJuYW0iOjEsIm5hbXAiOiJyaWdodCIsImNvbSI6MSwiY29tcCI6ImxlZnQiLCJwcmljZSI6MCwiYm9yIjoxLCJjb2wiOjAsImJidG4iOjEsInByb2QiOjB9',
      renta:
        '//ck.jp.ap.valuecommerce.com/servlet/referral?sid=3549505&pid=886731192&vc_url=https%3A%2F%2Frenta.papy.co.jp%2Frenta%2Fsc%2Ffrm%2Fitem%2F180398%2Ftitle%2F683851%2F%3Fref%3Dvc',
      cmoa:
        '//ck.jp.ap.valuecommerce.com/servlet/referral?sid=3549505&pid=886731152&vc_url=https%3A%2F%2Fwww.cmoa.jp%2Ftitle%2F1101234738%2Fvol%2F2%2F%3F%2F%3Fcmoa%3Ditag01%26cmoa_pg%3D125%26itag01%3D',
      ebookjapan:
        '//ck.jp.ap.valuecommerce.com/servlet/referral?sid=3549505&pid=886731133&vc_url=https%3A%2F%2Febookjapan.yahoo.co.jp%2Fbooks%2F526517%2FA002299596%2F%3Fdealerid%3D30064%26utm_source%3Dasp%26utm_medium%3Dvc%26utm_campaign%3Drate',
      honto:
        '//ck.jp.ap.valuecommerce.com/servlet/referral?sid=3549505&pid=886731272&vc_url=https%3A%2F%2Fhonto.jp%2Febook%2Fpd_30070149.html%3Fpartnerid%3D02vc01',
    },
    en: {
      asin: 'B01MYC6ZOZ',
      title: 'The Monet Murders (The Art of Murder #2)',
      url: 'https://www.amazon.co.jp/dp/B01MYC6ZOZ?tag=muchimemo-22',
      author: 'Josh Lanyon',
    },
  },
  monumentsMenMurders: {
    jp: {
      asin: 'B09C1MLWJH',
      title: 'モニュメンツメン・マーダーズ (殺しのアート #4)',
      url: 'https://www.amazon.co.jp/dp/B09C1MLWJH?tag=muchimemo-22',
      author: 'ジョシュ･ラニヨン',
    },
    en: {
      asin: 'B07R818GZ9',
      title: 'The Monuments Men Murders (The Art of Murder #4)',
      url: 'https://www.amazon.co.jp/dp/B07R818GZ9?tag=muchimemo-22',
      author: 'Josh Lanyon',
    },
  },
  fairGame: {
    jp: {
      asin: 'B00CB7WV66',
      title: "フェア･ゲーム (All's Fair #1)",
      url: 'https://www.amazon.co.jp/dp/B00CB7WV66?tag=muchimemo-22',
      author: 'ジョシュ･ラニヨン',
      rakuten:
        'https://hb.afl.rakuten.co.jp/ichiba/1ce58288.c1901dcf.1ce58289.c2be2c6c/?pc=https%3A%2F%2Fitem.rakuten.co.jp%2Frakutenkobo-ebooks%2F67213bea8a99318b9c1a18eb7084707e%2F&link_type=hybrid_url&ut=eyJwYWdlIjoiaXRlbSIsInR5cGUiOiJoeWJyaWRfdXJsIiwic2l6ZSI6IjI0MHgyNDAiLCJuYW0iOjEsIm5hbXAiOiJyaWdodCIsImNvbSI6MSwiY29tcCI6ImxlZnQiLCJwcmljZSI6MCwiYm9yIjoxLCJjb2wiOjAsImJidG4iOjEsInByb2QiOjB9',
      renta:
        '//ck.jp.ap.valuecommerce.com/servlet/referral?sid=3549505&pid=886731192&vc_url=https%3A%2F%2Frenta.papy.co.jp%2Frenta%2Fsc%2Ffrm%2Fitem%2F38455%2F%3Fref%3Dvc',
      cmoa:
        '//ck.jp.ap.valuecommerce.com/servlet/referral?sid=3549505&pid=886731152&vc_url=https%3A%2F%2Fwww.cmoa.jp%2Ftitle%2F1101035259%2F%3F%2F%3Fcmoa%3Ditag01%26cmoa_pg%3D125%26itag01%3D',
      ebookjapan:
        '//ck.jp.ap.valuecommerce.com/servlet/referral?sid=3549505&pid=886731133&vc_url=https%3A%2F%2Febookjapan.yahoo.co.jp%2Fbooks%2F262782%2FA000335144%2F%3Fdealerid%3D30064%26utm_source%3Dasp%26utm_medium%3Dvc%26utm_campaign%3Drate',
      honto:
        '//ck.jp.ap.valuecommerce.com/servlet/referral?sid=3549505&pid=886731272&vc_url=https%3A%2F%2Fhonto.jp%2Febook%2Fpd_25783968.html%3Fpartnerid%3D02vc01',
    },
    en: {
      asin: 'B003U89S66',
      title: "Fair Game (All's Fair #1)",
      url: 'https://www.amazon.co.jp/dp/B003U89S66?tag=muchimemo-22',
      author: 'Josh Lanyon',
      rakuten:
        'https://hb.afl.rakuten.co.jp/ichiba/1ce58288.c1901dcf.1ce58289.c2be2c6c/?pc=https%3A%2F%2Fitem.rakuten.co.jp%2Frakutenkobo-ebooks%2Fd7ee6d25152a3155a650a963de541d5e%2F&link_type=hybrid_url&ut=eyJwYWdlIjoiaXRlbSIsInR5cGUiOiJoeWJyaWRfdXJsIiwic2l6ZSI6IjI0MHgyNDAiLCJuYW0iOjEsIm5hbXAiOiJyaWdodCIsImNvbSI6MSwiY29tcCI6ImxlZnQiLCJwcmljZSI6MCwiYm9yIjoxLCJjb2wiOjAsImJidG4iOjEsInByb2QiOjB9',
    },
  },
  fairPlay: {
    jp: {
      asin: 'B01MUOQTHX',
      title: "フェア･プレイ (All's Fair #2)",
      url: 'https://www.amazon.co.jp/dp/B01MUOQTHX?tag=muchimemo-22',
      author: 'ジョシュ･ラニヨン',
      rakuten:
        'https://hb.afl.rakuten.co.jp/ichiba/1ce58288.c1901dcf.1ce58289.c2be2c6c/?pc=https%3A%2F%2Fitem.rakuten.co.jp%2Frakutenkobo-ebooks%2Fe3330763ba743f15b2f198e569cd025d%2F&link_type=text&ut=eyJwYWdlIjoiaXRlbSIsInR5cGUiOiJ0ZXh0Iiwic2l6ZSI6IjI0MHgyNDAiLCJuYW0iOjEsIm5hbXAiOiJyaWdodCIsImNvbSI6MSwiY29tcCI6ImxlZnQiLCJwcmljZSI6MCwiYm9yIjoxLCJjb2wiOjAsImJidG4iOjEsInByb2QiOjB9',
      renta:
        '//ck.jp.ap.valuecommerce.com/servlet/referral?sid=3549505&pid=886731192&vc_url=https%3A%2F%2Frenta.papy.co.jp%2Frenta%2Fsc%2Ffrm%2Fitem%2F122859%2F%3Fref%3Dvc',
      cmoa:
        '//ck.jp.ap.valuecommerce.com/servlet/referral?sid=3549505&pid=886731152&vc_url=https%3A%2F%2Fwww.cmoa.jp%2Ftitle%2F1101171031%2F%3F%2F%3Fcmoa%3Ditag01%26cmoa_pg%3D125%26itag01%3D',
      ebookjapan:
        '//ck.jp.ap.valuecommerce.com/servlet/referral?sid=3549505&pid=886731133&vc_url=https%3A%2F%2Febookjapan.yahoo.co.jp%2Fbooks%2F396451%2FA001718613%2F%3Fdealerid%3D30064%26utm_source%3Dasp%26utm_medium%3Dvc%26utm_campaign%3Drate',
      honto:
        '//ck.jp.ap.valuecommerce.com/servlet/referral?sid=3549505&pid=886731272&vc_url=https%3A%2F%2Fhonto.jp%2Febook%2Fpd_28328820.html%3Fpartnerid%3D02vc01',
    },
    en: {
      asin: 'B00KV5Z7M0',
      title: "Fair Play (All's Fair #2)",
      url: 'https://www.amazon.co.jp/dp/B00KV5Z7M0?tag=muchimemo-22',
      author: 'Josh Lanyon',
      rakuten: '',
    },
  },
  fairChance: {
    jp: {
      asin: 'B083NX8Q66',
      title: "フェア･チャンス (All's Fair #3)",
      url: 'https://www.amazon.co.jp/dp/B083NX8Q66?tag=muchimemo-22',
      author: 'ジョシュ･ラニヨン',
      rakuten:
        'https://hb.afl.rakuten.co.jp/ichiba/1ce58288.c1901dcf.1ce58289.c2be2c6c/?pc=https%3A%2F%2Fitem.rakuten.co.jp%2Frakutenkobo-ebooks%2F460b33c110e03018948ae59b8720ca97%2F&link_type=hybrid_url&ut=eyJwYWdlIjoiaXRlbSIsInR5cGUiOiJoeWJyaWRfdXJsIiwic2l6ZSI6IjI0MHgyNDAiLCJuYW0iOjEsIm5hbXAiOiJyaWdodCIsImNvbSI6MSwiY29tcCI6ImxlZnQiLCJwcmljZSI6MCwiYm9yIjoxLCJjb2wiOjAsImJidG4iOjEsInByb2QiOjB9',
      renta:
        '//ck.jp.ap.valuecommerce.com/servlet/referral?sid=3549505&pid=886731192&vc_url=https%3A%2F%2Frenta.papy.co.jp%2Frenta%2Fsc%2Ffrm%2Fitem%2F205328%2F%3Fref%3Dvc',
      cmoa:
        '//ck.jp.ap.valuecommerce.com/servlet/referral?sid=3549505&pid=886731152&vc_url=https%3A%2F%2Fwww.cmoa.jp%2Ftitle%2F1101266031%2F%3F%2F%3Fcmoa%3Ditag01%26cmoa_pg%3D125%26itag01%3D',
      ebookjapan:
        '//ck.jp.ap.valuecommerce.com/servlet/referral?sid=3549505&pid=886731133&vc_url=https%3A%2F%2Febookjapan.yahoo.co.jp%2Fbooks%2F574879%2FA002308254%2F%3Fdealerid%3D30064%26utm_source%3Dasp%26utm_medium%3Dvc%26utm_campaign%3Drate',
      honto:
        '//ck.jp.ap.valuecommerce.com/servlet/referral?sid=3549505&pid=886731272&vc_url=https%3A%2F%2Fhonto.jp%2Febook%2Fpd_30111073.html%3Fpartnerid%3D02vc01',
    },
    en: {
      asin: 'B01MSLD8L2',
      title: "Fair Chance (All's Fair #3)",
      url: 'https://www.amazon.co.jp/dp/B01MSLD8L2?tag=muchimemo-22',
      author: 'Josh Lanyon',
      rakuten:
        'https://hb.afl.rakuten.co.jp/ichiba/1ce58288.c1901dcf.1ce58289.c2be2c6c/?pc=https%3A%2F%2Fitem.rakuten.co.jp%2Frakutenkobo-ebooks%2Feb0ab0fa07a037e096b978a47e4ed41c%2F&link_type=hybrid_url&ut=eyJwYWdlIjoiaXRlbSIsInR5cGUiOiJoeWJyaWRfdXJsIiwic2l6ZSI6IjI0MHgyNDAiLCJuYW0iOjEsIm5hbXAiOiJyaWdodCIsImNvbSI6MSwiY29tcCI6ImxlZnQiLCJwcmljZSI6MCwiYm9yIjoxLCJjb2wiOjAsImJidG4iOjEsInByb2QiOjB9',
    },
    audiobook: {
      asin: 'B07GKL83HC',
      url: 'https://www.amazon.co.jp/dp/B07GKL83HC?tag=muchimemo-22',
      narrator: 'J. F. Harding',
    },
  },
  fatalShadows: {
    jp: {
      asin: 'B00KW25SO4',
      title: '天使の影 (アドリアン･イングリッシュ #1)',
      url: 'https://www.amazon.co.jp/dp/B00KW25SO4?tag=muchimemo-22',
      author: 'ジョシュ･ラニヨン',
      rakuten:
        'https://hb.afl.rakuten.co.jp/ichiba/1ce58288.c1901dcf.1ce58289.c2be2c6c/?pc=https%3A%2F%2Fitem.rakuten.co.jp%2Frakutenkobo-ebooks%2F04efd478cde13e19aee9a67e647367b0%2F&link_type=hybrid_url&ut=eyJwYWdlIjoiaXRlbSIsInR5cGUiOiJoeWJyaWRfdXJsIiwic2l6ZSI6IjI0MHgyNDAiLCJuYW0iOjEsIm5hbXAiOiJyaWdodCIsImNvbSI6MSwiY29tcCI6ImxlZnQiLCJwcmljZSI6MCwiYm9yIjoxLCJjb2wiOjAsImJidG4iOjEsInByb2QiOjB9',
      renta:
        '//ck.jp.ap.valuecommerce.com/servlet/referral?sid=3549505&pid=886731192&vc_url=https%3A%2F%2Frenta.papy.co.jp%2Frenta%2Fsc%2Ffrm%2Fitem%2F53135%2Ftitle%2F248320%2F%3Fref%3Dvc',
      cmoa:
        '//ck.jp.ap.valuecommerce.com/servlet/referral?sid=3549505&pid=886731152&vc_url=https%3A%2F%2Fwww.cmoa.jp%2Ftitle%2F1101057705%2F%3F%2F%3Fcmoa%3Ditag01%26cmoa_pg%3D125%26itag01%3D',
      ebookjapan:
        '//ck.jp.ap.valuecommerce.com/servlet/referral?sid=3549505&pid=886731133&vc_url=https%3A%2F%2Febookjapan.yahoo.co.jp%2Fbooks%2F262773%2FA000335131%2F%3Fdealerid%3D30064%26utm_source%3Dasp%26utm_medium%3Dvc%26utm_campaign%3Drate',
      honto:
        '//ck.jp.ap.valuecommerce.com/servlet/referral?sid=3549505&pid=886731272&vc_url=https%3A%2F%2Fhonto.jp%2Febook%2Fpd_26192074.html%3Fpartnerid%3D02vc01',
    },
    en: {
      asin: 'B007ZRH38I',
      title: 'Fatal Shadows (The Adrien English Mysteries #1)',
      url: 'https://www.amazon.co.jp/dp/B007ZRH38I?tag=muchimemo-22',
      author: 'Josh Lanyon',
    },
  },
  dangerousThing: {
    jp: {
      asin: 'B00KW25SP8',
      title: '死者の囁き (アドリアン･イングリッシュ #2)',
      url: 'https://www.amazon.co.jp/dp/B00KW25SP8?tag=muchimemo-22',
      author: 'ジョシュ･ラニヨン',
      rakuten:
        'https://hb.afl.rakuten.co.jp/ichiba/1ce58288.c1901dcf.1ce58289.c2be2c6c/?pc=https%3A%2F%2Fitem.rakuten.co.jp%2Frakutenkobo-ebooks%2F08e26e629fef3afa93e138d616f929c9%2F&link_type=hybrid_url&ut=eyJwYWdlIjoiaXRlbSIsInR5cGUiOiJoeWJyaWRfdXJsIiwic2l6ZSI6IjI0MHgyNDAiLCJuYW0iOjEsIm5hbXAiOiJyaWdodCIsImNvbSI6MSwiY29tcCI6ImxlZnQiLCJwcmljZSI6MCwiYm9yIjoxLCJjb2wiOjAsImJidG4iOjEsInByb2QiOjB9',
      renta:
        '//ck.jp.ap.valuecommerce.com/servlet/referral?sid=3549505&pid=886731192&vc_url=https%3A%2F%2Frenta.papy.co.jp%2Frenta%2Fsc%2Ffrm%2Fitem%2F53135%2Ftitle%2F248321%2F%3Fref%3Dvc',
      cmoa:
        '//ck.jp.ap.valuecommerce.com/servlet/referral?sid=3549505&pid=886731152&vc_url=https%3A%2F%2Fwww.cmoa.jp%2Ftitle%2F1101057705%2Fvol%2F2%2F%3F%2F%3Fcmoa%3Ditag01%26cmoa_pg%3D125%26itag01%3D',
      ebookjapan:
        '//ck.jp.ap.valuecommerce.com/servlet/referral?sid=3549505&pid=886731133&vc_url=https%3A%2F%2Febookjapan.yahoo.co.jp%2Fbooks%2F262773%2FA000335132%2F%3Fdealerid%3D30064%26utm_source%3Dasp%26utm_medium%3Dvc%26utm_campaign%3Drate',
      honto:
        '//ck.jp.ap.valuecommerce.com/servlet/referral?sid=3549505&pid=886731272&vc_url=https%3A%2F%2Fhonto.jp%2Febook%2Fpd_26192075.html%3Fpartnerid%3D02vc01',
    },
    en: {
      asin: 'B0081C8RU4',
      title: 'A Dangerous Thing (The Adrien English Mysteries #2)',
      url: 'https://www.amazon.co.jp/dp/B0081C8RU4?tag=muchimemo-22',
      author: 'Josh Lanyon',
    },
  },
  hellYouSay: {
    jp: {
      asin: 'B00N8RVP24',
      title: '悪魔の聖餐 (アドリアン･イングリッシュ #3)',
      url: 'https://www.amazon.co.jp/dp/B00N8RVP24?tag=muchimemo-22',
      author: 'ジョシュ･ラニヨン',
      rakuten:
        'https://hb.afl.rakuten.co.jp/ichiba/1ce58288.c1901dcf.1ce58289.c2be2c6c/?pc=https%3A%2F%2Fitem.rakuten.co.jp%2Frakutenkobo-ebooks%2Fcb923ddc0bff31ab9ad65929c15f009d%2F&link_type=hybrid_url&ut=eyJwYWdlIjoiaXRlbSIsInR5cGUiOiJoeWJyaWRfdXJsIiwic2l6ZSI6IjI0MHgyNDAiLCJuYW0iOjEsIm5hbXAiOiJyaWdodCIsImNvbSI6MSwiY29tcCI6ImxlZnQiLCJwcmljZSI6MCwiYm9yIjoxLCJjb2wiOjAsImJidG4iOjEsInByb2QiOjB9',
      renta:
        '//ck.jp.ap.valuecommerce.com/servlet/referral?sid=3549505&pid=886731192&vc_url=https%3A%2F%2Frenta.papy.co.jp%2Frenta%2Fsc%2Ffrm%2Fitem%2F53135%2Ftitle%2F276736%2F%3Fref%3Dvc',
      cmoa:
        '//ck.jp.ap.valuecommerce.com/servlet/referral?sid=3549505&pid=886731152&vc_url=https%3A%2F%2Fwww.cmoa.jp%2Ftitle%2F1101057705%2Fvol%2F3%2F%3F%2F%3Fcmoa%3Ditag01%26cmoa_pg%3D125%26itag01%3D',
      ebookjapan:
        '//ck.jp.ap.valuecommerce.com/servlet/referral?sid=3549505&pid=886731133&vc_url=https%3A%2F%2Febookjapan.yahoo.co.jp%2Fbooks%2F262773%2FA000335133%2F%3Fdealerid%3D30064%26utm_source%3Dasp%26utm_medium%3Dvc%26utm_campaign%3Drate',
      honto:
        '//ck.jp.ap.valuecommerce.com/servlet/referral?sid=3549505&pid=886731272&vc_url=https%3A%2F%2Fhonto.jp%2Febook%2Fpd_26475126.html%3Fpartnerid%3D02vc01',
    },
    en: {
      asin: 'B006LNC468',
      title: 'The Hell You Say (The Adrien English Mysteries #3)',
      url: 'https://www.amazon.co.jp/dp/B006LNC468?tag=muchimemo-22',
      author: 'Josh Lanyon',
    },
  },
  deathOfAPirateKing: {
    jp: {
      asin: 'B00U6WBU2E',
      title: '海賊王の死 (アドリアン･イングリッシュ #4)',
      url: 'https://www.amazon.co.jp/dp/B00U6WBU2E?tag=muchimemo-22',
      author: 'ジョシュ･ラニヨン',
      rakuten:
        'https://hb.afl.rakuten.co.jp/ichiba/1ce58288.c1901dcf.1ce58289.c2be2c6c/?pc=https%3A%2F%2Fitem.rakuten.co.jp%2Frakutenkobo-ebooks%2F09781469945e3c74b0acee10ad7d3ecf%2F&link_type=hybrid_url&ut=eyJwYWdlIjoiaXRlbSIsInR5cGUiOiJoeWJyaWRfdXJsIiwic2l6ZSI6IjI0MHgyNDAiLCJuYW0iOjEsIm5hbXAiOiJyaWdodCIsImNvbSI6MSwiY29tcCI6ImxlZnQiLCJwcmljZSI6MCwiYm9yIjoxLCJjb2wiOjAsImJidG4iOjEsInByb2QiOjB9',
      renta:
        '//ck.jp.ap.valuecommerce.com/servlet/referral?sid=3549505&pid=886731192&vc_url=https%3A%2F%2Frenta.papy.co.jp%2Frenta%2Fsc%2Ffrm%2Fitem%2F53135%2Ftitle%2F309332%2F%3Fref%3Dvc',
      cmoa:
        '//ck.jp.ap.valuecommerce.com/servlet/referral?sid=3549505&pid=886731152&vc_url=https%3A%2F%2Fwww.cmoa.jp%2Ftitle%2F1101057705%2Fvol%2F4%2F%3F%2F%3Fcmoa%3Ditag01%26cmoa_pg%3D125%26itag01%3D',
      ebookjapan:
        '//ck.jp.ap.valuecommerce.com/servlet/referral?sid=3549505&pid=886731133&vc_url=https%3A%2F%2Febookjapan.yahoo.co.jp%2Fbooks%2F262773%2FA001508666%2F%3Fdealerid%3D30064%26utm_source%3Dasp%26utm_medium%3Dvc%26utm_campaign%3Drate',
      honto:
        '//ck.jp.ap.valuecommerce.com/servlet/referral?sid=3549505&pid=886731272&vc_url=https%3A%2F%2Fhonto.jp%2Febook%2Fpd_27059000.html%3Fpartnerid%3D02vc01',
    },
    en: {
      asin: 'B0067QUX9E',
      title: 'Death of a Pirate King (The Adrien English Mysteries #4)',
      url: 'https://www.amazon.co.jp/dp/B0067QUX9E?tag=muchimemo-22',
      author: 'Josh Lanyon',
    },
  },
  darkTide: {
    jp: {
      asin: 'B01BL25AEG',
      title: '瞑き流れ (アドリアン･イングリッシュ #5)',
      url: 'https://www.amazon.co.jp/dp/B01BL25AEG?tag=muchimemo-22',
      author: 'ジョシュ･ラニヨン',
      rakuten:
        'https://hb.afl.rakuten.co.jp/ichiba/1ce58288.c1901dcf.1ce58289.c2be2c6c/?pc=https%3A%2F%2Fitem.rakuten.co.jp%2Frakutenkobo-ebooks%2F822673c680b53e36accb51d1cd419124%2F&link_type=hybrid_url&ut=eyJwYWdlIjoiaXRlbSIsInR5cGUiOiJoeWJyaWRfdXJsIiwic2l6ZSI6IjI0MHgyNDAiLCJuYW0iOjEsIm5hbXAiOiJyaWdodCIsImNvbSI6MSwiY29tcCI6ImxlZnQiLCJwcmljZSI6MCwiYm9yIjoxLCJjb2wiOjAsImJidG4iOjEsInByb2QiOjB9',
      renta:
        '//ck.jp.ap.valuecommerce.com/servlet/referral?sid=3549505&pid=886731192&vc_url=https%3A%2F%2Frenta.papy.co.jp%2Frenta%2Fsc%2Ffrm%2Fitem%2F53135%2Ftitle%2F352992%2F%3Fref%3Dvc',
      cmoa:
        '//ck.jp.ap.valuecommerce.com/servlet/referral?sid=3549505&pid=886731152&vc_url=https%3A%2F%2Fwww.cmoa.jp%2Ftitle%2F1101057705%2Fvol%2F5%2F%3F%2F%3Fcmoa%3Ditag01%26cmoa_pg%3D125%26itag01%3D',
      ebookjapan:
        '//ck.jp.ap.valuecommerce.com/servlet/referral?sid=3549505&pid=886731133&vc_url=https%3A%2F%2Febookjapan.yahoo.co.jp%2Fbooks%2F262773%2FA001614757%2F%3Fdealerid%3D30064%26utm_source%3Dasp%26utm_medium%3Dvc%26utm_campaign%3Drate',
      honto:
        '//ck.jp.ap.valuecommerce.com/servlet/referral?sid=3549505&pid=886731272&vc_url=https%3A%2F%2Fhonto.jp%2Febook%2Fpd_27726334.html%3Fpartnerid%3D02vc01',
    },
    en: {
      asin: 'B006N9XHLQ',
      title: 'The Dark Tide (The Adrien English Mysteries #5)',
      url: 'https://www.amazon.co.jp/dp/B006N9XHLQ?tag=muchimemo-22',
      author: 'Josh Lanyon',
    },
  },
  soThisIsChristmas: {
    jp: {
      asin: 'B077ZGFZ7S',
      title: 'So This is Christmas (アドリアン･イングリッシュ #6)',
      url: 'https://www.amazon.co.jp/dp/B077ZGFZ7S?tag=muchimemo-22',
      author: 'ジョシュ･ラニヨン',
      rakuten:
        'https://hb.afl.rakuten.co.jp/ichiba/1ce58288.c1901dcf.1ce58289.c2be2c6c/?pc=https%3A%2F%2Fitem.rakuten.co.jp%2Frakutenkobo-ebooks%2F2b0ff3ab413236a8a4a30d21eded4f35%2F&link_type=hybrid_url&ut=eyJwYWdlIjoiaXRlbSIsInR5cGUiOiJoeWJyaWRfdXJsIiwic2l6ZSI6IjI0MHgyNDAiLCJuYW0iOjEsIm5hbXAiOiJyaWdodCIsImNvbSI6MSwiY29tcCI6ImxlZnQiLCJwcmljZSI6MCwiYm9yIjoxLCJjb2wiOjAsImJidG4iOjEsInByb2QiOjB9',
      renta:
        '//ck.jp.ap.valuecommerce.com/servlet/referral?sid=3549505&pid=886731192&vc_url=https%3A%2F%2Frenta.papy.co.jp%2Frenta%2Fsc%2Ffrm%2Fitem%2F145549%2F%3Fref%3Dvc',
      cmoa:
        '//ck.jp.ap.valuecommerce.com/servlet/referral?sid=3549505&pid=886731152&vc_url=https%3A%2F%2Fwww.cmoa.jp%2Ftitle%2F1101201484%2F%3F%2F%3Fcmoa%3Ditag01%26cmoa_pg%3D125%26itag01%3D',
      ebookjapan:
        '//ck.jp.ap.valuecommerce.com/servlet/referral?sid=3549505&pid=886731133&vc_url=https%3A%2F%2Febookjapan.yahoo.co.jp%2Fbooks%2F442663%2FA001837800%2F%3Fdealerid%3D30064%26utm_source%3Dasp%26utm_medium%3Dvc%26utm_campaign%3Drate',
      honto:
        '//ck.jp.ap.valuecommerce.com/servlet/referral?sid=3549505&pid=886731272&vc_url=https%3A%2F%2Fhonto.jp%2Febook%2Fpd_28919885.html%3Fpartnerid%3D02vc01',
    },
    en: {
      asin: 'B01N9AERR2',
      title: 'So This is Christmas (The Adrien English Mysteries #6)',
      url: 'https://www.amazon.co.jp/dp/B01N9AERR2?tag=muchimemo-22',
      author: 'Josh Lanyon',
    },
    audiobook: {
      asin: 'B07DP5VDT6',
      url: 'https://www.amazon.co.jp/dp/B07DP5VDT6?tag=muchimemo-22',
      narrator: 'Kale Williams ',
    },
  },
  winterKill: {
    jp: {
      asin: 'B08W9688D7',
      title: 'ウィンター･キル',
      url: 'https://www.amazon.co.jp/dp/B08W9688D7?tag=muchimemo-22',
      author: 'ジョシュ･ラニヨン',
    },
    en: {
      asin: 'B00UB6FY7C',
      title: 'Winter Kill',
      url: 'https://www.amazon.co.jp/dp/B00UB6FY7C?tag=muchimemo-22',
      author: 'Josh Lanyon',
    },
  },
  caseOfChristmas: {
    jp: {
      asin: 'B07J5FW3ZS',
      title: 'クリスマスの航路',
      url: 'https://www.amazon.co.jp/dp/B07J5FW3ZS?tag=muchimemo-22',
      author: 'ジョシュ･ラニヨン',
    },
    en: {
      asin: 'B018SVP9T4',
      title: 'A Case of Christmas',
      url: 'https://www.amazon.co.jp/dp/B018SVP9T4?tag=muchimemo-22',
      author: 'Josh Lanyon',
    },
  },
  strangerOnTheShore: {
    jp: {
      asin: '',
      title: '',
      url: '',
      author: '',
      rakuten: '',
    },
    en: {
      asin: 'B00I15VL86',
      title: 'Stranger on the Shore',
      url: 'https://www.amazon.co.jp/dp/B00I15VL86?tag=muchimemo-22',
      author: 'Josh Lanyon',
      rakuten: '',
    },
  },
  loversAndOtherStrangers: {
    jp: {
      asin: '',
      title: '',
      url: '',
      author: '',
      rakuten: '',
    },
    en: {
      asin: 'B0062QD68O',
      title: 'Lovers and Other Strangers',
      url: 'https://www.amazon.co.jp/dp/B0062QD68O?tag=muchimemo-22',
      author: 'Josh Lanyon',
      rakuten: '',
    },
  },
  murderAtPiratesCove: {
    jp: {
      asin: '',
      title: '',
      url: '',
      author: '',
      rakuten: '',
    },
    en: {
      asin: 'B0826X61C9',
      title: "Murder at Pirate's Cove",
      url: 'https://www.amazon.co.jp/dp/B0826X61C9?tag=muchimemo-22',
      author: 'Josh Lanyon',
      rakuten: '',
    },
  },
  dontLookBack: {
    jp: {
      asin: 'B00HD59DYY',
      title: 'ドント･ルックバック',
      url: 'https://www.amazon.co.jp/dp/B00HD59DYY?tag=muchimemo-22',
      author: 'ジョシュ･ラニヨン',
      rakuten:
        'https://hb.afl.rakuten.co.jp/ichiba/1ce58288.c1901dcf.1ce58289.c2be2c6c/?pc=https%3A%2F%2Fitem.rakuten.co.jp%2Frakutenkobo-ebooks%2F4990a1830a40363e8d98f21eff808248%2F&link_type=hybrid_url&ut=eyJwYWdlIjoiaXRlbSIsInR5cGUiOiJoeWJyaWRfdXJsIiwic2l6ZSI6IjI0MHgyNDAiLCJuYW0iOjEsIm5hbXAiOiJyaWdodCIsImNvbSI6MSwiY29tcCI6ImxlZnQiLCJwcmljZSI6MCwiYm9yIjoxLCJjb2wiOjAsImJidG4iOjEsInByb2QiOjB9',
      renta:
        '//ck.jp.ap.valuecommerce.com/servlet/referral?sid=3549505&pid=886731192&vc_url=https%3A%2F%2Frenta.papy.co.jp%2Frenta%2Fsc%2Ffrm%2Fitem%2F48307%2F%3Fref%3Dvc',
      cmoa:
        '//ck.jp.ap.valuecommerce.com/servlet/referral?sid=3549505&pid=886731152&vc_url=https%3A%2F%2Fwww.cmoa.jp%2Ftitle%2F1101057702%2F%3F%2F%3Fcmoa%3Ditag01%26cmoa_pg%3D125%26itag01%3D',
      ebookjapan:
        '//ck.jp.ap.valuecommerce.com/servlet/referral?sid=3549505&pid=886731133&vc_url=https%3A%2F%2Febookjapan.yahoo.co.jp%2Fbooks%2F262780%2FA000335142%2F%3Fdealerid%3D30064%26utm_source%3Dasp%26utm_medium%3Dvc%26utm_campaign%3Drate',
      honto:
        '//ck.jp.ap.valuecommerce.com/servlet/referral?sid=3549505&pid=886731272&vc_url=https%3A%2F%2Fhonto.jp%2Febook%2Fpd_26192077.html%3Fpartnerid%3D02vc01',
    },
    en: {
      asin: 'B00891DC8Y',
      title: "Don't Look Back",
      url: 'https://www.amazon.co.jp/dp/B00891DC8Y?tag=muchimemo-22',
      author: 'Josh Lanyon',
      rakuten:
        'https://hb.afl.rakuten.co.jp/ichiba/1ce58288.c1901dcf.1ce58289.c2be2c6c/?pc=https%3A%2F%2Fitem.rakuten.co.jp%2Frakutenkobo-ebooks%2Fed0a25fccf11429ca9117e7a7a8eb21e%2F&link_type=hybrid_url&ut=eyJwYWdlIjoiaXRlbSIsInR5cGUiOiJoeWJyaWRfdXJsIiwic2l6ZSI6IjI0MHgyNDAiLCJuYW0iOjEsIm5hbXAiOiJyaWdodCIsImNvbSI6MSwiY29tcCI6ImxlZnQiLCJwcmljZSI6MCwiYm9yIjoxLCJjb2wiOjAsImJidG4iOjEsInByb2QiOjB9',
    },
  },
  speechless: {
    jp: {
      asin: 'B01BL25AC8',
      title: 'Speechless',
      url: 'https://www.amazon.co.jp/dp/B01BL25AC8?tag=muchimemo-22',
      author: 'キム･フィールディング',
      rakuten:
        'https://hb.afl.rakuten.co.jp/ichiba/1ce58288.c1901dcf.1ce58289.c2be2c6c/?pc=https%3A%2F%2Fitem.rakuten.co.jp%2Frakutenkobo-ebooks%2Fb73d85a576943a0cab69dab2778532f7%2F&link_type=hybrid_url&ut=eyJwYWdlIjoiaXRlbSIsInR5cGUiOiJoeWJyaWRfdXJsIiwic2l6ZSI6IjI0MHgyNDAiLCJuYW0iOjEsIm5hbXAiOiJyaWdodCIsImNvbSI6MSwiY29tcCI6ImxlZnQiLCJwcmljZSI6MCwiYm9yIjoxLCJjb2wiOjAsImJidG4iOjEsInByb2QiOjB9',
      renta:
        '//ck.jp.ap.valuecommerce.com/servlet/referral?sid=3549505&pid=886731192&vc_url=https%3A%2F%2Frenta.papy.co.jp%2Frenta%2Fsc%2Ffrm%2Fitem%2F95811%2F%3Fref%3Dvc',
      cmoa:
        '//ck.jp.ap.valuecommerce.com/servlet/referral?sid=3549505&pid=886731152&vc_url=https%3A%2F%2Fwww.cmoa.jp%2Ftitle%2F1101141411%2F%3F%2F%3Fcmoa%3Ditag01%26cmoa_pg%3D125%26itag01%3D',
      ebookjapan:
        '//ck.jp.ap.valuecommerce.com/servlet/referral?sid=3549505&pid=886731133&vc_url=https%3A%2F%2Febookjapan.yahoo.co.jp%2Fbooks%2F350837%2F%3Fdealerid%3D30064%26utm_source%3Dasp%26utm_medium%3Dvc%26utm_campaign%3Drate',
      honto:
        '//ck.jp.ap.valuecommerce.com/servlet/referral?sid=3549505&pid=886731272&vc_url=https%3A%2F%2Fhonto.jp%2Febook%2Fpd_27726335.html%3Fpartnerid%3D02vc01',
    },
    en: {
      asin: 'B008MMXCMQ',
      title: 'Speechless',
      url: 'https://www.amazon.co.jp/dp/B008MMXCMQ?tag=muchimemo-22',
      author: 'Kim Fielding',
      rakuten:
        'https://hb.afl.rakuten.co.jp/ichiba/1ce58288.c1901dcf.1ce58289.c2be2c6c/?pc=https%3A%2F%2Fitem.rakuten.co.jp%2Frakutenkobo-ebooks%2F7add86d1da383d26a3108e265ca42bf7%2F&link_type=hybrid_url&ut=eyJwYWdlIjoiaXRlbSIsInR5cGUiOiJoeWJyaWRfdXJsIiwic2l6ZSI6IjI0MHgyNDAiLCJuYW0iOjEsIm5hbXAiOiJyaWdodCIsImNvbSI6MSwiY29tcCI6ImxlZnQiLCJwcmljZSI6MCwiYm9yIjoxLCJjb2wiOjAsImJidG4iOjEsInByb2QiOjB9',
    },
  },
  theGig: {
    jp: {
      asin: '',
      title: '',
      url: '',
      author: 'キム･フィールディング',
    },
    en: {
      asin: 'B0722W3LRN',
      title: 'The Gig',
      url: 'https://www.amazon.co.jp/dp/B0722W3LRN?tag=muchimemo-22',
      author: 'Kim Fielding',
    },
  },
  howToHowlAtTheMoon: {
    jp: {
      asin: 'B07J67WTTM',
      title: '月への吠えかた教えます (月吠えシリーズ #1)',
      url: 'https://www.amazon.co.jp/dp/B07J67WTTM?tag=muchimemo-22',
      author: 'イーライ･イーストン',
      rakuten:
        'https://hb.afl.rakuten.co.jp/ichiba/1ce58288.c1901dcf.1ce58289.c2be2c6c/?pc=https%3A%2F%2Fitem.rakuten.co.jp%2Frakutenkobo-ebooks%2F1a3115309cbb36c7a2c54bcdc4a51275%2F&link_type=hybrid_url&ut=eyJwYWdlIjoiaXRlbSIsInR5cGUiOiJoeWJyaWRfdXJsIiwic2l6ZSI6IjI0MHgyNDAiLCJuYW0iOjEsIm5hbXAiOiJyaWdodCIsImNvbSI6MSwiY29tcCI6ImxlZnQiLCJwcmljZSI6MCwiYm9yIjoxLCJjb2wiOjAsImJidG4iOjEsInByb2QiOjB9',
      renta:
        '//ck.jp.ap.valuecommerce.com/servlet/referral?sid=3549505&pid=886731192&vc_url=https%3A%2F%2Frenta.papy.co.jp%2Frenta%2Fsc%2Ffrm%2Fitem%2F176493%2F%3Fref%3Dvc',
      cmoa:
        '//ck.jp.ap.valuecommerce.com/servlet/referral?sid=3549505&pid=886731152&vc_url=https%3A%2F%2Fwww.cmoa.jp%2Ftitle%2F1101230119%2F%3F%2F%3Fcmoa%3Ditag01%26cmoa_pg%3D125%26itag01%3D',
      ebookjapan:
        '//ck.jp.ap.valuecommerce.com/servlet/referral?sid=3549505&pid=886731133&vc_url=https%3A%2F%2Febookjapan.yahoo.co.jp%2Fbooks%2F518971%2FA002091480%2F%3Fdealerid%3D30064%26utm_source%3Dasp%26utm_medium%3Dvc%26utm_campaign%3Drate',
      honto:
        '//ck.jp.ap.valuecommerce.com/servlet/referral?sid=3549505&pid=886731272&vc_url=https%3A%2F%2Fhonto.jp%2Febook%2Fpd_29430927.html%3Fpartnerid%3D02vc01',
    },
    en: {
      asin: 'B00T12QQOW',
      title: 'How to Howl at the Moon (Howl at the Moon #1)',
      url: 'https://www.amazon.co.jp/dp/B00T12QQOW?tag=muchimemo-22',
      author: 'Eli Easton',
    },
    audiobook: {
      asin: 'B07DY6YW8H',
      url: 'https://www.amazon.co.jp/dp/B07DY6YW8H?tag=muchimemo-22',
      narrator: 'Matthew Shaw',
    },
  },
  howToWalkLikeAMan: {
    jp: {
      asin: 'B07YXLFLG9',
      title: 'ヒトの世界の歩きかた (月吠えシリーズ #2)',
      url: 'https://www.amazon.co.jp/dp/B07YXLFLG9?tag=muchimemo-22',
      author: 'イーライ･イーストン',
      rakuten:
        'https://hb.afl.rakuten.co.jp/ichiba/1ce58288.c1901dcf.1ce58289.c2be2c6c/?pc=https%3A%2F%2Fitem.rakuten.co.jp%2Frakutenkobo-ebooks%2F8bfabd82d37a3ff7b47843046ae2b4dc%2F&link_type=hybrid_url&ut=eyJwYWdlIjoiaXRlbSIsInR5cGUiOiJoeWJyaWRfdXJsIiwic2l6ZSI6IjI0MHgyNDAiLCJuYW0iOjEsIm5hbXAiOiJyaWdodCIsImNvbSI6MSwiY29tcCI6ImxlZnQiLCJwcmljZSI6MCwiYm9yIjoxLCJjb2wiOjAsImJidG4iOjEsInByb2QiOjB9',
      renta:
        '//ck.jp.ap.valuecommerce.com/servlet/referral?sid=3549505&pid=886731192&vc_url=https%3A%2F%2Frenta.papy.co.jp%2Frenta%2Fsc%2Ffrm%2Fitem%2F198677%2F%3Fref%3Dvc',
      cmoa:
        '//ck.jp.ap.valuecommerce.com/servlet/referral?sid=3549505&pid=886731152&vc_url=https%3A%2F%2Fwww.cmoa.jp%2Ftitle%2F1101257824%2F%3F%2F%3Fcmoa%3Ditag01%26cmoa_pg%3D125%26itag01%3D',
      ebookjapan:
        '//ck.jp.ap.valuecommerce.com/servlet/referral?sid=3549505&pid=886731133&vc_url=https%3A%2F%2Febookjapan.yahoo.co.jp%2Fbooks%2F563859%2FA002257876%2F%3Fdealerid%3D30064%26utm_source%3Dasp%26utm_medium%3Dvc%26utm_campaign%3Drate',
      honto:
        '//ck.jp.ap.valuecommerce.com/servlet/referral?sid=3549505&pid=886731272&vc_url=https%3A%2F%2Fhonto.jp%2Febook%2Fpd_29951028.html%3Fpartnerid%3D02vc01',
    },
    en: {
      asin: 'B0176KQPH8',
      title: 'How to Walk Like a Man (Howl at the Moon #2)',
      url: 'https://www.amazon.co.jp/dp/B0176KQPH8?tag=muchimemo-22',
      author: 'Eli Easton',
    },
  },
  howToWishUponAStar: {
    jp: {
      asin: 'B08MW9PG12',
      title: '星に願いをかけるには (月吠えシリーズ #3)',
      url: 'https://www.amazon.co.jp/dp/B08MW9PG12?tag=muchimemo-22',
      author: 'イーライ･イーストン',
      rakuten:
        'https://hb.afl.rakuten.co.jp/ichiba/1ce58288.c1901dcf.1ce58289.c2be2c6c/?pc=https%3A%2F%2Fitem.rakuten.co.jp%2Frakutenkobo-ebooks%2Fe002d23c17dc3e949c46d3fe6d6318f8%2F&link_type=hybrid_url&ut=eyJwYWdlIjoiaXRlbSIsInR5cGUiOiJoeWJyaWRfdXJsIiwic2l6ZSI6IjI0MHgyNDAiLCJuYW0iOjEsIm5hbXAiOiJyaWdodCIsImNvbSI6MSwiY29tcCI6ImRvd24iLCJwcmljZSI6MSwiYm9yIjoxLCJjb2wiOjEsImJidG4iOjEsInByb2QiOjAsImFtcCI6ZmFsc2V9',
      renta:
        '//ck.jp.ap.valuecommerce.com/servlet/referral?sid=3549505&pid=886731192&vc_url=https%3A%2F%2Frenta.papy.co.jp%2Frenta%2Fsc%2Ffrm%2Fitem%2F235066%2F%3Fref%3Dvc',
      cmoa:
        '//ck.jp.ap.valuecommerce.com/servlet/referral?sid=3549505&pid=886731152&vc_url=https%3A%2F%2Fwww.cmoa.jp%2Ftitle%2F1101293534%2F%3F%2F%3Fcmoa%3Ditag01%26cmoa_pg%3D125%26itag01%3D',
      ebookjapan:
        '//ck.jp.ap.valuecommerce.com/servlet/referral?sid=3549505&pid=886731133&vc_url=https%3A%2F%2Febookjapan.yahoo.co.jp%2Fbooks%2F614798%2FA002481320%2F%3Fdealerid%3D30064%26utm_source%3Dasp%26utm_medium%3Dvc%26utm_campaign%3Drate',
      honto:
        '//ck.jp.ap.valuecommerce.com/servlet/referral?sid=3549505&pid=886731272&vc_url=https%3A%2F%2Fhonto.jp%2Febook%2Fpd_30690147.html%3Fpartnerid%3D02vc01',
    },
    en: {
      asin: 'B01FISHWJK',
      title: 'How to Wish Upon a Star (Howl at the Moon #3)',
      url: 'https://www.amazon.co.jp/dp/B01FISHWJK?tag=muchimemo-22',
      author: 'Eli Easton',
    },
  },
  catchAGhost: {
    jp: {
      asin: 'B01BL25ADW',
      title: '幽霊狩り (ヘル･オア･ハイウォーター #1)',
      url: 'https://www.amazon.co.jp/dp/B01BL25ADW?tag=muchimemo-22',
      author: 'S･E･ジェイクス',
      rakuten:
        'https://hb.afl.rakuten.co.jp/ichiba/1ce58288.c1901dcf.1ce58289.c2be2c6c/?pc=https%3A%2F%2Fitem.rakuten.co.jp%2Frakutenkobo-ebooks%2Ff33bd5abebcb3edda5dbdaabfe5e9f06%2F&link_type=hybrid_url&ut=eyJwYWdlIjoiaXRlbSIsInR5cGUiOiJoeWJyaWRfdXJsIiwic2l6ZSI6IjI0MHgyNDAiLCJuYW0iOjEsIm5hbXAiOiJyaWdodCIsImNvbSI6MSwiY29tcCI6ImxlZnQiLCJwcmljZSI6MCwiYm9yIjoxLCJjb2wiOjAsImJidG4iOjEsInByb2QiOjB9',
      renta:
        '//ck.jp.ap.valuecommerce.com/servlet/referral?sid=3549505&pid=886731192&vc_url=https%3A%2F%2Frenta.papy.co.jp%2Frenta%2Fsc%2Ffrm%2Fitem%2F95810%2Ftitle%2F352990%2F%3Fref%3Dvc',
      cmoa:
        '//ck.jp.ap.valuecommerce.com/servlet/referral?sid=3549505&pid=886731152&vc_url=https%3A%2F%2Fwww.cmoa.jp%2Ftitle%2F1101141410%2F%3F%2F%3Fcmoa%3Ditag01%26cmoa_pg%3D125%26itag01%3D',
      ebookjapan:
        '//ck.jp.ap.valuecommerce.com/servlet/referral?sid=3549505&pid=886731133&vc_url=https%3A%2F%2Febookjapan.yahoo.co.jp%2Fbooks%2F350836%2FA001614759%2F%3Fdealerid%3D30064%26utm_source%3Dasp%26utm_medium%3Dvc%26utm_campaign%3Drate',
      honto:
        '//ck.jp.ap.valuecommerce.com/servlet/referral?sid=3549505&pid=886731272&vc_url=https%3A%2F%2Fhonto.jp%2Febook%2Fpd_27726340.html%3Fpartnerid%3D02vc01',
    },
    en: {
      asin: 'B00F1XU31W',
      title: 'Catch a Ghost (Hell or High Water #1)',
      url: 'https://www.amazon.co.jp/dp/B00F1XU31W?tag=muchimemo-22',
      author: 'SE Jakes',
      rakuten:
        'https://hb.afl.rakuten.co.jp/ichiba/1ce58288.c1901dcf.1ce58289.c2be2c6c/?pc=https%3A%2F%2Fitem.rakuten.co.jp%2Frakutenkobo-ebooks%2Fcf336ecb4aa6370688e671a89bec68c9%2F&link_type=hybrid_url&ut=eyJwYWdlIjoiaXRlbSIsInR5cGUiOiJoeWJyaWRfdXJsIiwic2l6ZSI6IjI0MHgyNDAiLCJuYW0iOjEsIm5hbXAiOiJyaWdodCIsImNvbSI6MSwiY29tcCI6ImxlZnQiLCJwcmljZSI6MCwiYm9yIjoxLCJjb2wiOjAsImJidG4iOjEsInByb2QiOjB9',
    },
  },
}
